import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetLocationsList = () =>
  useMutation({
    mutationFn: (data) => client(`resources/sites/${data}`),
  });

export const useGetCountries = () =>
  useMutation({
    mutationFn: () => client("lookups/countries"),
  });
export const useAddLocation = () =>
  useMutation({
    mutationFn: (data) =>
      client("resources/sites/add", {
        data,
        successMessage: "Service point added successfully",
      }),
  });
export const useEditLocation = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/sites/edit`, {
        data,
        successMessage: "Service point updated successfully",
      }),
  });
export const useGetLocation = () =>
  useMutation({
    mutationFn: (locationId) => client(`resources/sites/${locationId}`),
  });

export const useExportLocationSlaConf = () =>
  useMutation({
    mutationFn: (data) =>
      client("sla/configuration/location/export", {
        data,
      }),
  });

export const useImportLocationSlaConf = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/location/import`, {
        method: "post",
        data,
        successMessage: "Locations detail imported successfully",
      }),
  });

export const useGetLocationSlaDefaults = () =>
  useMutation({
    mutationFn: (locationId) =>
      client(
        `sla/configuration/location/defaults?servicePointId=${locationId}`,
        { method: "get" },
      ),
  });

export const useGetLocationSlaDefaultsByCustomerCity = () =>
  useMutation({
    mutationFn: ({ customerId, city }) =>
      client(
        `sla/configuration/location/defaults/?customerId=${customerId}&city=${city}`,
      ),
  });
